"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    addDomainIDHeaderPlugin: ()=>addDomainIDHeaderPlugin
});
const index_js_namespaceObject = require("../../domain-id/index.js");
const external_tool_js_namespaceObject = require("../../tool.js");
function addDomainIDHeaderPlugin(addDomainIDHeaderConfig) {
    return {
        request: [
            async (config)=>{
                var _config_pluginConfig, _config_pluginConfig1;
                var _config_pluginConfig_domainID;
                const domainID = null != (_config_pluginConfig_domainID = null == (_config_pluginConfig = config.pluginConfig) ? void 0 : _config_pluginConfig.domainID) ? _config_pluginConfig_domainID : (0, external_tool_js_namespaceObject.tryCatch)(index_js_namespaceObject.getCurrentDomainID, (error)=>{
                    console.error({
                        message: null == error ? void 0 : error.message,
                        position: 'addDomainIDHeaderPlugin',
                        context: {
                            jwtPluginConfig: addDomainIDHeaderConfig,
                            globalPluginConfig: config.pluginConfig,
                            currentDomainID: index_js_namespaceObject.currentDomainID
                        }
                    });
                    throw error;
                });
                var _addDomainIDHeaderConfig_enabledDomainIDs;
                const enabledDomainIDs = null != (_addDomainIDHeaderConfig_enabledDomainIDs = null == addDomainIDHeaderConfig ? void 0 : addDomainIDHeaderConfig.enabledDomainIDs) ? _addDomainIDHeaderConfig_enabledDomainIDs : [
                    'ttp-us-limited',
                    'ttp-us'
                ];
                if (enabledDomainIDs.includes(domainID) && (null == (_config_pluginConfig1 = config.pluginConfig) ? void 0 : _config_pluginConfig1.enableDomainIDHeader)) {
                    var _config_headers;
                    config.headers = null != (_config_headers = config.headers) ? _config_headers : {};
                    config.headers['x-domain-id'] = domainID;
                }
                return config;
            }
        ]
    };
}
exports.addDomainIDHeaderPlugin = __webpack_exports__.addDomainIDHeaderPlugin;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "addDomainIDHeaderPlugin"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
